import type { Color } from '@xox/shared'
import { SHIRT_FILL } from '../../lib/flair'

interface Props {
  color: Color
  className?: string
  /** A crashed cycle is drawn faded, on its side. */
  wrecked?: boolean
}

/** A light cycle seen from the side, trailing a short glowing wall. Lineups, podiums, standings. */
export function Cycle({ color, className = '', wrecked = false }: Props) {
  const fill = SHIRT_FILL[color]
  return (
    <svg
      viewBox="0 0 48 24"
      className={`${className} ${wrecked ? 'opacity-40' : ''}`}
      style={{ aspectRatio: '2 / 1' }}
      aria-hidden
    >
      <g transform={wrecked ? 'rotate(-14 24 12)' : undefined}>
        {/* the wall it leaves behind */}
        <rect x="0" y="13" width="18" height="3" rx="1.5" fill={fill} opacity=".55" />
        <rect x="6" y="13.8" width="12" height="1.4" rx=".7" fill="white" opacity=".5" />
        {/* body */}
        <path
          d="M17 16 C19 8 25 5 33 5 L40 5 C44 5 47 8 47 12 L47 14 C47 15.5 45.5 17 44 17 L20 17 C18.5 17 17 16.5 17 16 Z"
          fill="var(--cycles-body)"
        />
        <path d="M22 13 L30 8 L38 8 L36 13 Z" fill={fill} />
        {/* wheels */}
        <circle cx="25" cy="17" r="5" fill="var(--cycles-body)" />
        <circle cx="25" cy="17" r="2.6" fill={fill} />
        <circle cx="41" cy="17" r="5" fill="var(--cycles-body)" />
        <circle cx="41" cy="17" r="2.6" fill={fill} />
        {/* headlight */}
        <circle cx="46" cy="10" r="1.4" fill="white" />
      </g>
    </svg>
  )
}
